import { render, staticRenderFns } from "./25November.vue?vue&type=template&id=27dc3cac"
import script from "./25November.vue?vue&type=script&lang=js"
export * from "./25November.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports